import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { FederatorOnboardingService } from '../../construct-x/data-space/services/federator-onboarding.service';

/** Keeps Construct-X workspaces unavailable until the organisation has joined the data space. */
@Injectable({ providedIn: 'root' })
export class ConstructXOnboardingGuard implements CanActivate {
  constructor(private readonly onboarding: FederatorOnboardingService, private readonly router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | UrlTree {
    const organisationId = [...route.pathFromRoot].reverse()
      .map(snapshot => Number(snapshot.paramMap.get('organisationId')))
      .find(id => Number.isInteger(id) && id > 0);
    if (!organisationId) return this.router.createUrlTree(['/marktplatz']);

    return this.onboarding.status(organisationId).pipe(
      map(status => status?.status === 'accepted'
        ? true
        : this.router.createUrlTree(['/organisations', organisationId, 'data-space-onboarding'])),
      catchError(() => of(this.router.createUrlTree(['/organisations', organisationId, 'data-space-onboarding'])))
    );
  }
}
